<template>
  <RequireAdContract>
    <div class="content">
      <div class="row align-center">
        <div class="large-11 columns">
          <section class="form-section">
            <h1 class="form-section__title">
              {{ $t('ADVERTISEMENT.FINANCE.INVOICE') }}
            </h1>
            <div class="row align-justify">
              <div class="small-12 large-4 columns">
                <p class="form-section__description">
                  {{ $t('ADVERTISEMENT.FINANCE.INVOICE_DESC') }}
                </p>
              </div>
              <div class="small-12 large-7 columns">
                <div class="card">
                  <ElForm label-position="top">
                    <div class="card__block">
                      <ElFormItem :label="$t('DATE_RANGE')">
                        <ElSelect
                          v-model="selectedRangeId"
                          class="show-for-medium"
                          filterable
                          :disabled="invoiceProcessing"
                          :placeholder="$t('PICK_A_DATE_RANGE')"
                        >
                          <ElOption
                            v-for="range in invoiceRanges"
                            :key="range[2]"
                            :value="range[2]"
                            :label="
                              `${translateDate(range[0])} - ${translateDate(
                                range[1],
                              )}`
                            "
                          />
                        </ElSelect>

                        <select
                          v-model="selectedRangeId"
                          class="hide-for-medium"
                          :disabled="invoiceProcessing"
                        >
                          <option value="" disabled>
                            {{ $t('PICK_A_DATE_RANGE') }}
                          </option>
                          <option
                            v-for="range in invoiceRanges"
                            :key="range[2]"
                            :value="range[2]"
                          >
                            {{
                              `${translateDate(range[0])} - ${translateDate(
                                range[1],
                              )}`
                            }}
                          </option>
                        </select>
                      </ElFormItem>

                      <ErrorsList
                        v-if="InvoiceFormErrors"
                        :errors="InvoiceFormErrors"
                      />

                      <ElButton
                        type="primary"
                        native-type="submit"
                        :loading="invoiceProcessing"
                        :disabled="selectedRangeId === ''"
                        @click.native.prevent="
                          downloadInvoiceFile(selectedRangeId)
                        "
                      >
                        <i class="material-icons">
                          file_download
                        </i>
                        <span>{{ $t('DOWNLOAD_INVOICE') }}</span>
                      </ElButton>
                    </div>
                  </ElForm>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </RequireAdContract>
</template>

<script>
import RequireAdContract from '../common/RequireAdContract';
import FileSaver from 'file-saver';

import { AdvertisementInvoice, Advertisement } from '@/api/api';

import ErrorsList from '@@/common/ErrorsList';
import layout from '@/mixins/layout';
import lang from '@/mixins/lang';
import { dateFormat } from '@/utils/date';

export default {
  name: 'Invoice',

  components: {
    ErrorsList,
    RequireAdContract,
  },

  mixins: [layout, lang],

  data() {
    return {
      invoiceRanges: [],
      selectedRangeId: '',
      invoiceProcessing: false,

      InvoiceFormErrors: null,
    };
  },

  created() {
    this.getInvoiceRanges();
  },

  methods: {
    getInvoiceRanges() {
      return Advertisement.getInvoiceRanges()
        .then(({ body: { range = [] } }) => {
          this.invoiceRanges = [...range];
          for (let i = 0; i < this.invoiceRanges.length; i += 1) {
            this.invoiceRanges[i][2] = i;
          }
          this.selectedRangeId = 0;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },

    translateDate(date) {
      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      return dateFormat()(toFormat)(date);
    },

    downloadInvoiceFile(selectedRangeId) {
      this.invoiceProcessing = true;
      const range = this.invoiceRanges[selectedRangeId];
      return AdvertisementInvoice.get({
        start_date: range[0],
        end_date: range[1],
      })
        .then(response => response.blob())
        .then(invoiceBlob => {
          FileSaver.saveAs(invoiceBlob, 'sales_invoice.pdf');
          this.InvoiceFormErrors = null;
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
          if (errors) {
            this.InvoiceFormErrors = [...errors];
          }
        })
        .then(() => {
          this.invoiceProcessing = false;
        });
    },
  },
};
</script>
